import { BalanceBlockStatus } from 'types/BalanceBlock';

export const BalanceBlockStatusDescription = {
	[BalanceBlockStatus.UNBLOCKING]: 'Aguardando desbloqueio',
	[BalanceBlockStatus.BLOCKING]: 'Aguardando bloqueio',
	[BalanceBlockStatus.ACTIVE]: 'Bloqueio ativo',
	[BalanceBlockStatus.REMOVED]: 'Removido',
};
